import type { AccessTag, Site } from "../types";

export const TAG_LABELS: Record<AccessTag, string> = {
  "drive-up": "Drive-up",
  overnight: "Overnight",
  dispersed: "Dispersed / boondock",
  "designated-camp": "Designated camp",
  "length-friendly": "Larger-van friendly",
  "short-rigs": "Short rigs",
  "high-clearance": "High clearance",
  permit: "Permit",
};

export function bortleLabel(bortle: number): string {
  return `Bortle ${bortle}`;
}

export function bortleTone(bortle: number): string {
  if (bortle <= 2) return "Excellent dark sky";
  if (bortle === 3) return "Good, some skyglow";
  return "Accessible, not pristine";
}

export function overnightLabel(site: Site): string {
  if (site.overnight === "dispersed") return "Dispersed overnight";
  if (site.overnight === "mixed") return "Campground + dispersed";
  return "Designated overnight";
}

export function matchesFilters(
  site: Site,
  filters: {
    region: Site["region"] | "";
    driveUp: boolean;
    overnight: boolean;
    lengthFriendly: boolean;
  },
): boolean {
  if (filters.region && site.region !== filters.region) return false;
  if (filters.driveUp && !site.driveUp) return false;
  if (filters.overnight && !site.tags.includes("overnight")) return false;
  if (filters.lengthFriendly && !site.lengthFriendly) return false;
  return true;
}
